import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const navLinks = [
  { label: "Services", to: "/services" },
  { label: "How It Works", to: "/#how-it-works" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (to: string) => location.pathname === to;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-card/90 backdrop-blur supports-[backdrop-filter]:bg-card/75">
      <div className="container-narrow flex h-16 items-center justify-between px-4 md:px-8 lg:px-16">
        <Link to="/" className="flex items-center gap-2" onClick={() => setMobileOpen(false)}>
          <span className="font-display text-base font-extrabold tracking-tight text-primary">
            ELEVATE <span className="text-secondary">GLOBAL</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative px-3 py-2 text-sm font-medium transition-colors hover:text-primary ${
                isActive(link.to) ? "text-primary" : "text-muted-foreground"
              }`}
            >
              {link.label}
              {isActive(link.to) && (
                <span className="absolute inset-x-3 -bottom-px h-0.5 bg-secondary" />
              )}
            </Link>
          ))}
          <a
            href="tel:+12142962124"
            className="ml-2 hidden items-center gap-1.5 rounded-md px-2.5 py-2 text-sm font-semibold text-primary transition-colors hover:text-secondary lg:inline-flex"
          >
            <Phone className="h-3.5 w-3.5" />
            (214) 296-2124
          </a>
          <Link to="/book" className="ml-2">
            <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold">
              Book a Free Call
              <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </Link>
        </nav>

        <button
          className="inline-flex items-center justify-center rounded-md p-2 text-foreground md:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-border bg-card md:hidden">
          <nav className="container-narrow flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`rounded-md px-3 py-2.5 text-sm font-medium transition-colors hover:bg-accent ${
                  isActive(link.to) ? "bg-accent text-primary font-semibold" : "text-muted-foreground"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/book" onClick={() => setMobileOpen(false)} className="mt-2">
              <Button className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold">
                Book a Free Call
              </Button>
            </Link>
            <a
              href="tel:+12142962124"
              onClick={() => setMobileOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-md border border-border px-3 py-2.5 text-sm font-semibold text-primary"
            >
              <Phone className="h-4 w-4" />
              (214) 296-2124
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
